import { useEffect, useState } from "react";
import { AlphaCard, DatePicker, Icon, Popover, Stack, TextField, Tooltip } from "@shopify/polaris";
import { AlertMinor, CalendarMinor } from "@shopify/polaris-icons";

function removeDayFromCurrentDate(days) {
  let currentDate = new Date();
  return new Date(currentDate.setDate(currentDate.getDate() - days));
}

const formattedValue = (date) => {
  const selectedDate = new Date(date);

  const yyyy = selectedDate.getFullYear();
  let mm: number | string = selectedDate.getMonth() + 1; // Months start at 0!
  let dd: number | string = selectedDate.getDate();


  if (Number(dd) < 10) {
    dd = `0${dd}`;
  }

  if (Number(mm) < 10) {
    mm = `0${mm}`;
  }

  return dd + "/" + mm + "/" + yyyy;
};

function DateField({ input }) {
  const [visible, setVisible] = useState(false);

  const [{ month, year }, setDate] = useState(() => {
    const date = new Date();
    return {
      month: date.getMonth(),
      year: date.getFullYear()
    };
  });

  function handleOnClose(source) {
    setVisible(false);
  }

  function handleMonthChange(month, year) {
    setDate({ month, year });
  }

  function handleDateSelection({ end: newSelectedDate }) {
    setVisible(false);
    input.onChange({ ...input.value, selectedDate: newSelectedDate.toDateString() });
  }

  useEffect(() => {
    if (input.value.selectedDate) {
      const date = new Date(input.value.selectedDate);
      setDate({
        month: date.getMonth(),
        year: date.getFullYear()
      });
    }
  }, [input]);

  return (
    <Popover
      active={visible}
      autofocusTarget="none"
      preferredAlignment="left"
      fullWidth
      preferInputActivator={false}
      preferredPosition="below"
      preventCloseOnChildOverlayClick
      onClose={handleOnClose}
      activator={
        <TextField
          role="combobox"
          label={
            <Stack alignment={"center"}>
              <span>Date</span>
              <Tooltip
                content="All dates and times within Stockhide are based on the UTC timezone."
                padding={"4"}
                preferredPosition={"above"}
              >
                <Icon
                  source={AlertMinor}
                  color="base"
                />
              </Tooltip>
            </Stack>
          }
          suffix={<Icon source={CalendarMinor} />}
          value={formattedValue(input.value.selectedDate)}
          onFocus={() => {
            if (!input.value.disableAction) {
              return;
            }
            setVisible(true);
          }}
          autoComplete="off"
          readOnly
          disabled={!input.value.disableAction}
        />
      }
    >
      <AlphaCard>
        <div style={{ minWidth: "270px" }}>
          <DatePicker
            month={month}
            year={year}
            selected={new Date(input.value.selectedDate)}
            onMonthChange={handleMonthChange}
            onChange={handleDateSelection}
            disableDatesBefore={removeDayFromCurrentDate(1)}
          />
        </div>
      </AlphaCard>
    </Popover>
  );
}

export default DateField;